import { useEffect } from 'react';
import { Layout } from 'antd';
import AppFooter from './footer';
import SiderMenu from './siderMenu';
import { Outlet } from 'react-router';
import AppHeader from './header';
import { useDispatch } from 'react-redux';
import { fetchRolesList } from '../../state/slices/rolesListSlice';
import { useUserAuth } from '../../context/UserContext';
import { fetchUserCountries, fetchLogTypes, fetchOrderStatuses, fetchQuotations, fetchRpaTemplateTypes, fetchSalesOrganization, fetchTemplates, fetchTemplateTypes, fetchCountries } from '../../state/slices/utilsSlice';

const { Content, } = Layout;

const MainLayout = () => {

    const dispatch = useDispatch();
    const { user } = useUserAuth();

    useEffect(() => {
        if (!user) return;
        dispatch(fetchRolesList() as any);
        dispatch(fetchTemplates(user) as any);
        dispatch(fetchSalesOrganization() as any);
        dispatch(fetchUserCountries(user.id) as any);
        dispatch(fetchCountries() as any);
        dispatch(fetchQuotations() as any);
        dispatch(fetchOrderStatuses() as any);
        dispatch(fetchRpaTemplateTypes() as any);
        dispatch(fetchLogTypes(user.roleCode) as any);
        dispatch(fetchTemplateTypes() as any);
    }, [dispatch, user]); // ✅ API calls run once on app load

    return (
        <Layout style={{ minHeight: '100vh' }} className='layout'>
            <SiderMenu />
            <Layout>
                <AppHeader />
                <Content className='content'>
                    <Outlet />
                </Content>
                <AppFooter />
            </Layout>
        </Layout>
    );
};

export default MainLayout;